const initHeaderSearch = () => {
	const search = document.querySelector('.site-header .search-form');
	const searchInput = document.querySelector('.site-header .search-field');

	search.onmouseover = (el) => {
		search.classList.add('active');
		searchInput.focus();
	}

	document.addEventListener('click', el => {
		if( ! el.target.classList.contains('search-submit') && ! el.target.classList.contains('search-field') && ! el.target.classList.contains('search-form') ) {
			search.classList.remove('active');
		}
	});

}

document.addEventListener('DOMContentLoaded', initHeaderSearch);